"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var React = _interopRequireWildcard(require("react"));
var _preview = _interopRequireDefault(require("../icons/preview"));
var _link = _interopRequireDefault(require("./link"));
var _colors = require("../../birch/colors");
var _excluded = ["children", "href"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var birchVersion = {
  linkColor: _colors.FullPalette.GREEN_700
};

// @ts-expect-error - TS2344 - Type 'Record<any, any>' does not satisfy the constraint 'keyof IntrinsicElements | ComponentType<any>'.
var StyledLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "external_link__StyledLink"
})(["svg{margin-left:4px;}"]);
function ExternalLink(props) {
  var children = props.children,
    href = props.href,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return (
    /*#__PURE__*/
    // @ts-expect-error - TS2769 - No overload matches this call. | TS2746 - This JSX tag's 'children' prop expects a single child of type 'never', but multiple children were provided.
    React.createElement(StyledLink, (0, _extends2["default"])({
      href: href
    }, rest, {
      target: "_blank",
      rel: "noopener norefferer"
    }), children, /*#__PURE__*/React.createElement(_preview["default"], {
      color: birchVersion.linkColor,
      size: 12
    }))
  );
}
var _default = exports["default"] = ExternalLink;